import { createContext, useContext } from 'react'
import { NavItemContext as ContextType } from './Types'

export const NavItemContext = createContext<ContextType>({
  isActive: false,
  isHovered: false,
})

export const useNavItemContext = () => {
  return useContext(NavItemContext)
}
